import { baseApi } from 'api'
import { invalidateTagsIfSuccess } from 'api/helpers'
import { ApiResponse } from 'helpers/types'
import {
  AuthInitRequest,
  AuthInitResponse,
  AuthInitTokenResponse,
  AuthItem,
  AuthRefreshRequest,
  AuthRefreshResponse,
  UserInfo,
  UserInfoResponse
} from 'schema'
import { authActions } from 'store/auth'
import { cleanAuthData } from 'store/auth/auth'
import { store } from 'store/store'

import { setAuthInfo } from '../helpers/token/token'

export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    userInfo: build.query<UserInfo, void>({
      query: () => ({
        url: 'user/info',
        method: 'GET'
      }),
      transformResponse: (response: ApiResponse<UserInfoResponse>) => {
        // @ts-ignore
        store.dispatch(authActions.setUserData(response.data.user))

        return response.data.user
      }
    }),
    logout: build.mutation<string, string>({
      query: () => ({
        url: 'auth',
        method: 'DELETE'
      }),
      transformResponse: (response: string) => {
        cleanAuthData()
        localStorage.isLogged = false

        return response
      },
      invalidatesTags: invalidateTagsIfSuccess(['USER', 'ORDER_LIST', 'CUSTOMER_LIST'])
    }),
    authInit: build.query<string, AuthInitRequest>({
      query: ({ username }) => ({
        url: 'auth-init',
        method: 'POST',
        body: {
          username
        }
      }),
      transformResponse: (response: ApiResponse<AuthInitResponse>) => response.data.widgetUrl
    }),
    orderAuthInit: build.query<string, AuthInitRequest>({
      query: ({ username }) => ({
        url: 'order-auth-init',
        method: 'POST',
        body: {
          username
        }
      }),
      transformResponse: (response: ApiResponse<AuthInitResponse>) => response.data.widgetUrl
    }),
    orderYarcheAuthInit: build.query<string, AuthInitRequest>({
      query: ({ username }) => ({
        url: 'order-yarche-auth-init',
        method: 'POST',
        body: {
          username
        }
      }),
      transformResponse: (response: ApiResponse<AuthInitResponse>) => response.data.widgetUrl
    }),
    authInitToken: build.query<AuthItem, { code: string; state: string }>({
      query: ({ code, state }) => ({
        url: 'auth-init',
        method: 'GET',
        params: {
          code,
          state
        }
      }),
      transformResponse: (response: ApiResponse<AuthInitTokenResponse>) => response.data.auth
    }),
    authRefresh: build.query<AuthItem, AuthRefreshRequest>({
      query: ({ refreshToken, token }) => ({
        url: 'auth-refresh',
        method: 'POST',
        body: {
          refreshToken,
          token
        }
      }),
      transformResponse: (response: ApiResponse<AuthRefreshResponse>) => {
        setAuthInfo(response.data.auth)
        localStorage.isLogged = true

        return response.data.auth
      }
    })
  }),
  overrideExisting: false
})

export const {
  useLogoutMutation,
  useUserInfoQuery,
  useLazyAuthInitQuery,
  useLazyOrderAuthInitQuery,
  useLazyOrderYarcheAuthInitQuery,
  useLazyAuthInitTokenQuery
} = authApi

export const authSelector = authApi.endpoints.userInfo.select()
export const authDataSelector = (state: any) => authSelector(state).data
